
export class VehicleReqId{
    reqId:number

    constructor(
       reqId:number,    

    ){
        this.reqId=reqId
    }
}